module.exports = __webpack_public_path__ + "img/album05_04.a8d8138e.jpg";